module.exports = __webpack_public_path__ + "static/media/Logo.3aa0d315.png";